import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import axios from "../../../services/axiosConfig";
import Helper from "../../../services/Helper";

const ProductDetails = () => {
  const [pageDetails, setPageDetails] = useState();
  const productStoreDetails = useSelector((state) => state.product.product);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios
          .post("/variant-attributes", {
            attributes: productStoreDetails.selectedAttributs,
          })
          .catch((error) => {
            Helper.ErrorHanlder(error);
          });
        if (res.data.data) {
          setPageDetails(res.data.data);
        }
        localStorage.removeItem("productDetails");
      } catch (error) {
        Helper.ErrorHanlder(error);
      }
    })();
  }, []);

  const CustomComponent = ({ pageDetails }) => {
    let attributes = _.map(pageDetails, "Attributes");
    let result = pageDetails;
    let style = {
      width:
        Number(100) /
          (Number(pageDetails.length == 1 ? 0 : pageDetails.length) +
            Number(4)) +
        "%",
      padding: "10px",
    };

    const [productcDetails, setProductDetails] = useState([]);

    const updatePrice = (val) => {
      if (productcDetails && productcDetails[val.value]) {
        productcDetails[val.value] = val;
        setProductDetails(...[productcDetails]);
      } else {
        productcDetails.push(val);
        setProductDetails(productcDetails);
      }

      localStorage.setItem("productDetails", JSON.stringify(productcDetails));
    };

    if (pageDetails.length > 1) {
      result = attributes.reduce((a, b) =>
        a.reduce((r, v) => r.concat(b.map((w) => [].concat(v, w))), [])
      );

      return result.map((obj, index) => (
        <>
          {obj.map((val, i) => {
            return (
              <div
                className="input-group input-group-sm mb-3"
                style={style}
                key={val.id}
              >
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-sm"
                  key={i + 1}
                >
                  {pageDetails[i].name}
                </span>
                <input
                  type="text"
                  className="form-control product-create-pg-inputs"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  disabled={true}
                  value={val.name}
                  key={`text${i + 1}`}
                />
              </div>
            );
          })}
          <div
            className="input-group input-group-sm mb-3"
            style={style}
            key={index}
          >
            <span
              className="input-group-text"
              id="inputGroup-sizing-sm"
              key={obj.id}
            >
              Points
            </span>
            <input
              type="number"
              id={`points${index}`}
              className="form-control product-create-pg-inputs"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              key={`points${index + 1}`}
              onChange={(e) => {
                updatePrice({
                  attributes: _.map(obj, "id"),
                  points: e.target.value,
                  price: document.getElementById(`price${index}`).value,
                  courier: document.getElementById(`courier${index}`).value,
                  webPrice: document.getElementById(`webPrice${index}`).value,
                  value: index,
                });
              }}
            />
          </div>
          <div
            className="input-group input-group-sm mb-3"
            style={style}
            key={index}
          >
            <span
              className="input-group-text"
              id="inputGroup-sizing-sm"
              key={obj.id}
            >
              Price
            </span>
            <input
              type="number"
              id={`price${index}`}
              className="form-control product-create-pg-inputs"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              key={`price${index + 1}`}
              onChange={(e) => {
                updatePrice({
                  attributes: _.map(obj, "id"),
                  points: document.getElementById(`points${index}`).value,
                  courier: document.getElementById(`courier${index}`).value,
                  webPrice: document.getElementById(`webPrice${index}`).value,
                  price: e.target.value,
                  value: index,
                });
              }}
            />
          </div>
          <div
            className="input-group input-group-sm mb-3"
            style={style}
            key={index}
          >
            <span
              className="input-group-text"
              id="inputGroup-sizing-sm"
              key={obj.id}
            >
              courier
            </span>
            <input
              type="number"
              id={`courier${index}`}
              className="form-control product-create-pg-inputs"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              key={`courier${index + 1}`}
              onChange={(e) => {
                updatePrice({
                  attributes: _.map(obj, "id"),
                  price: document.getElementById(`price${index}`).value,
                  points: document.getElementById(`points${index}`).value,
                  webPrice: document.getElementById(`webPrice${index}`).value,
                  courier: e.target.value,
                  value: index,
                });
              }}
            />
          </div>
          <div
            className="input-group input-group-sm mb-3"
            style={style}
            key={index}
          >
            <span
              className="input-group-text"
              id="inputGroup-sizing-sm"
              key={obj.id}
            >
              Retail Price
            </span>
            <input
              type="number"
              id={`webPrice${index}`}
              className="form-control product-create-pg-inputs"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              key={`webPrice${index + 1}`}
              onChange={(e) => {
                updatePrice({
                  attributes: _.map(obj, "id"),
                  price: document.getElementById(`price${index}`).value,
                  points: document.getElementById(`points${index}`).value,
                  courier: document.getElementById(`courier${index}`).value,
                  webPrice: e.target.value,
                  value: index,
                });
              }}
            />
          </div>
        </>
      ));
    } else if (pageDetails.length === 1) {
      return result[0].Attributes.map((val, i) => (
        <div
          key={`row-${i}`}
          className="d-flex mb-3"
          style={{
            display: "flex",
            alignItems: "flex-start",
            flexWrap: "nowrap",
          }}
        >
          <div
            className="input-group input-group-sm"
            style={style}
            key={`input-group-sm${i}`}
          >
            <span
              className="input-group-text"
              id="inputGroup-sizing-sm"
              key={`lable${i}`}
            >
              {result[0].name}
            </span>
            <input
              type="text"
              key={`input${i}`}
              className="form-control product-create-pg-inputs"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              disabled={true}
              value={val.name}
            />
          </div>

          <div
            className="input-group input-group-sm"
            style={style}
            key={`points-group-${i}`}
          >
            <span
              className="input-group-text"
              id="inputGroup-sizing-sm"
              key={`points-label-${i}`}
            >
              Points
            </span>
            <input
              type="number"
              id={`points${i}`}
              className="form-control product-create-pg-inputs"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              key={`points${i + 1}`}
              onChange={(e) => {
                updatePrice({
                  attributes: [val.id],
                  points: e.target.value,
                  price: document.getElementById(`price${i}`).value,
                  webPrice: document.getElementById(`webPrice${i}`).value,
                  courier: document.getElementById(`courier${i}`).value,
                  value: i,
                });
              }}
            />
          </div>

          <div
            className="input-group input-group-sm"
            style={style}
            key={`price-group-${i}`}
          >
            <span
              className="input-group-text"
              id={`inputGroup-sizing-sm${i}`}
              key={`inputGroup-sizing-sm${i}`}
            >
              Price
            </span>
            <input
              type="text"
              id={`price${i}`}
              key={`price${i}`}
              className="form-control product-create-pg-inputs"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              onChange={(e) => {
                updatePrice({
                  attributes: [val.id],
                  points: document.getElementById(`points${i}`).value,
                  webPrice: document.getElementById(`webPrice${i}`).value,
                  courier: document.getElementById(`courier${i}`).value,
                  price: e.target.value,
                  value: i,
                });
              }}
            />
          </div>

          <div
            className="input-group input-group-sm"
            style={style}
            key={`courier-group-${i}`}
          >
            <span
              className="input-group-text"
              id={`inputGroup-sizing-sm-courier-${i}`}
              key={`inputGroup-sizing-sm-courier-${i}`}
            >
              Courier
            </span>
            <input
              type="text"
              id={`courier${i}`}
              key={`courier${i}`}
              className="form-control product-create-pg-inputs"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              onChange={(e) => {
                updatePrice({
                  attributes: [val.id],
                  points: document.getElementById(`points${i}`).value,
                  webPrice: document.getElementById(`webPrice${i}`).value,
                  courier: e.target.value,
                  value: i,
                });
              }}
            />
          </div>

          <div
            className="input-group input-group-sm"
            style={style}
            key={`webPrice-group-${i}`}
          >
            <span
              className="input-group-text"
              id={`inputGroup-sizing-sm-web-${i}`}
              key={`inputGroup-sizing-sm-web-${i}`}
            >
              Retail Price
            </span>
            <input
              type="text"
              id={`webPrice${i}`}
              key={`webPrice${i}`}
              className="form-control product-create-pg-inputs"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              onChange={(e) => {
                updatePrice({
                  attributes: [val.id],
                  points: document.getElementById(`points${i}`).value,
                  price: document.getElementById(`price${i}`).value,
                  courier: document.getElementById(`courier${i}`).value,
                  webPrice: e.target.value,
                  value: i,
                });
              }}
            />
          </div>
        </div>
      ));
    }
  };

  return (
    <div className="product-creat-pg-step3">
      {pageDetails && <CustomComponent pageDetails={pageDetails} />}
    </div>
  );
};

export default ProductDetails;
